import {
  loginAPI,
  getCurrentUserInfo,
  registerUser,
  captchaLogin,
} from "@/apis/user";
import { setToken, getToken, removeToken } from "@/utils/auth";
export default {
  namespaced: true,
  state: () => {
    return {
      studentToken: getToken() || "",
      studentUserInfo: {},
      isRedirecting: false,
    };
  },
  mutations: {
    setToken(state, studentToken) {
      state.studentToken = studentToken;
      setToken(studentToken);
    },
    clearUserInfo(state) {
      state.studentToken = "";
      removeToken();
      localStorage.removeItem("studentUserInfo");
    },
    setUserInfo(state, userInfo) {
      state.studentUserInfo = userInfo;
      localStorage.setItem("studentUserInfo", JSON.stringify(userInfo));
    },
    setIsRedirecting(state, value) {
      state.isRedirecting = value;
    },
  },
  actions: {
    async doLogin(ctx, { username, password }) {
      const res = await loginAPI({ username, password });
      if (res.errCode === 0) {
        ctx.commit("setToken", res.data.accessToken);
        const res1 = await getCurrentUserInfo();
        if (res1.studentList.length > 0) {
          res1.studentList[0].mobile = res1.mobile;
          ctx.commit("setUserInfo", res1.studentList[0]);
        }
      } else {
        return Promise.reject(res.msg);
      }
    },
    async captchaLogin(ctx, data) {
      const res = await captchaLogin(data);
      if (res.errCode === 0) {
        ctx.commit("setToken", res.data);
        const res1 = await getCurrentUserInfo();
        if (res1.studentList.length > 0) {
          res1.studentList[0].mobile = res1.mobile;
          ctx.commit("setUserInfo", res1.studentList[0]);
        }
      } else {
        return Promise.reject(res.msg);
      }
    },
    async doRegister(ctx, data) {
      const res = await registerUser(data);
      if (res.errCode === 0) {
        ctx.commit("setToken", res.data);
        const res1 = await getCurrentUserInfo();
        if (res1.studentList.length > 0) {
          res1.studentList[0].mobile = res1.mobile;
          ctx.commit("setUserInfo", res1.studentList[0]);
        }
      } else {
        return Promise.reject(res.msg);
      }
    },
    clear(ctx) {
      ctx.commit("clearUserInfo");
    },
    async fetchUserInfo(ctx) {
      try {
        const res = await getCurrentUserInfo();
        if (res.studentList.length > 0) {
          res.studentList[0].mobile = res.mobile;
          ctx.commit("setUserInfo", res.studentList[0]);
        }
      } catch (error) {
        console.log("用户 info:这里错了", error);
      }
    },
  },
  getters: {
    token: (state) => state.studentToken,
    userInfo: (state) => state.studentUserInfo,
    isRedirecting: (state) => state.isRedirecting,
  },
};
